import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/TransmitterSetting/Fetch'
import ActionDelete from '../../store/action/TransmitterSetting/Delete'

import "../../source/util.css"
import { PrevilageId, ClientId } from '../../helper/HelperAuth'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import Swal from "sweetalert2";


class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Transmitter Setting",
            form: fromJS({
                show: false,
                isadmin:false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            searchForm: fromJS({
                "sender-id": "",
                "client-id": '',
                "division-id": "",
            }),
            search: fromJS([
                { widthClass: 'col-sm-12', id: 'search', placeholder: 'Search', label: '', value: '' },
            ]),
            columns: [
                { className: "col-sm-2", field: "client-name", caption: "Client Name", allowSearch: true },
                { className: "col-sm-2", field: "sender", caption: "Sender", allowSearch: true },
                { className: "col-sm-2", field: "sender-id", caption: "Sender Id", allowSearch: true },
                { className: "col-sm-2", field: "base-url", caption: "Base URL", allowSearch: true },
                { className: "col-sm-2", field: "contact-url", caption: "Contact URL", allowSearch: true },
                { className: "col-sm-2", field: "login-url", caption: "Login URL", allowSearch: true },
                { className: "col-sm-2", field: "message-url", caption: "Message URL", allowSearch: true },
                { className: "col-sm-1", cfield: "action", caption: "Actions", allowView: false }
            ],
            errors: fromJS({})
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        //new
        this.handleFind = this.handleFind.bind(this);
    }

    async componentDidMount() {
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        this.props.actionGetAllClient()
    }

    handleSearch(obj) {
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field, value);

        if (field === 'client-id') {
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
        }

        if(field === 'division-id'){
            this.props.actionGetAllSender(formVal.get('client-id'),value);
        }
        this.setState({ searchForm: formVal })
    }

    handleCancelForm(refresh) {
        if (refresh) {
            //new
            this.handleFindSearch(1);
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    async handleRemoveClicked(value) {
        var body = {
            "data": {
                "sender-id": value.get('sender-id')
            }
        };
        //debugger;
        var temp = await this.props.actionDelete(body);
        if (temp.ok) {
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete ' + value.get('sender') + ' Success!', toast.POSITION.TOP_RIGHT);
            this.handleFindSearch(1);
        } else {
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete ' + value.get('sender') + ' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    refreshGrid(page, search) {
        //new
        this.handleFindSearch(page);
    }

    showContent() {
        var form = this.state.form;


        if (form.get('show')) {
            return (
                <Form
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Form>
            )
        } else {
            const items = this.props.transmitter ? fromJS(this.props.transmitter) : fromJS({});
            return (
                <CustomGrid
                    title="Settings Transmitter"
                    columns={this.state.columns}
                    items={items}
                    search={this.state.search}
                    handleSearch={this.handleSearch}
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                // handleNew={ this.handleNew }
                >
                </CustomGrid>
            )
        }
    }

    handleFind() {
        this.handleFindSearch(1);
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let res = null;
        let client_id = searchForm.get('client-id');
        let sender_id = searchForm.get('sender-id');
        //debugger
        let sender = [""];
        var bodyFInd = {};
        var isAdmin = this.state.isadmin

        if (PrevilageId != 1 && isAdmin == false && client_id == "") client_id = ClientId;
        // this.props.actionGetAllSender(client_id)

        setTimeout(() => {
            res = this.props.senderall;
            if (res.size > 0) sender = [];
            {
                res.map((data, i) =>
                    sender.push(data.get('sender-id'))
                )
            }

            if (sender_id != "") sender = [sender_id]

            if (sender.length == 1 && sender[0] == null) {
                setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) sender.shift();
                    {
                        res.map((dataSender, i) =>
                            sender.push(dataSender.get('sender-id'))
                        )
                    }
                    if (res.size == 0) sender = [""]
                    if (PrevilageId != 1 && isAdmin == false && (client_id == "" || client_id == null)) client_id = ClientId
                    if ((PrevilageId == 1 || isAdmin == true)&& (client_id == "" || client_id == null)) client_id = 0
                    bodyFInd = { 
                        "sender-id": sender,
                        "client-id": client_id
                    }

                    this.props.actionGet(page, this.state.sortForm, bodyFInd);
                }, 1500);
            } else {
                if (PrevilageId != 1 && isAdmin == false && (client_id == "" || client_id == null)) client_id = ClientId
                if ((PrevilageId == 1 || isAdmin == true) && (client_id == "" || client_id == null)) client_id = 0
                bodyFInd = {
                    "sender-id": sender,
                    "client-id": client_id
                }

                this.props.actionGet(page, this.state.sortForm, bodyFInd);
            }
        }, 1500);


    }

    render() {
        const { form, searchForm } = this.state;
        const title = form.get('show') ? (form.get('actionType') === IsCreate ? "Add" : "Edit") : "Settings Transmitter";
        const classHide = title == "Settings Transmitter" ? 'card show' : 'card hidden';

        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className={classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Division"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success content-add"
                                    onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            senderall: state.user.senders,
            divisionall: state.user.divisionall,
            transmitter: state.user.gettransmitter
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionDelete: ActionDelete,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllSender: ActionGetAllSender,
        actionFindByGroupId:ActionFindByGroupId,
        actionGetAllDivision: ActionGetAllDivision,

    }, dispatch),
)(Page);